import React, { useState, useEffect, useRef } from 'react'
import { NavLink, useLocation } from 'react-router-dom';
import ProductosMenu from './ProductosMenu'
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import './MenuBar.scss'
import { useActiveDesactiveSrollBody } from '../hooks/activeDesactivScrollBody'
import { IoIosArrowForward, IoIosArrowRoundForward } from 'react-icons/io'
import { connect } from 'react-redux'
import { setAllProducts, setProductsTable, resetFilters, pushFilters, setSelectedCategory, setPaginationState, showSpinner } from '../actions'
import { selectCategoryExpositor, selectCategoryImplantations, selectCategoryOutlet } from '../hooks/selectCategory';
import { useNavigate } from 'react-router-dom';
import { PreChangeBrandChosen } from '../hooks/config';
import { PopupOneButton } from './PopupOneButton';
import { DeromaLogo, ScheurichLogo } from '../utils/icons';
import { BRANDCHOSEN } from '../hooks/config';

const MenuBar = (props) => {
    console.log("MenuBar props=", props);
     const navigate = useNavigate();
    const location = useLocation();

    const { menu, closeDrawer } = props

    const [isModalOpen, setModalOpen] = useState(false);
    const [isModalOpenImplantaciones, setModalOpenImplantaciones] = useState(false);
    const [showPopupPresupuestosPendientes, setShowPopupPresupuestosPendientes] = useState(false)

    useEffect(() => {
        console.log("menu, MenuBar useEffect = isModalOpen", isModalOpen);
        useActiveDesactiveSrollBody(isModalOpen)
    }, [isModalOpen])

    const handleClickOutlet = async () => {
      if (location.pathname !== '/outlet') {
        changeBrandGlobal().then((res)=>{
            console.log("handleClickOutlet outlet res=",res);
          if(res == true) {
            selectCategoryOutlet(props).then(res => {
                navigate('/outlet')
            }).catch(err => {
                console.log('err', err)
            })
          }
        })
      }
    };
    
    const changeBrandGlobal = (marca = 'fansa') => {
      return new Promise(async (resolve)=>{
        let marcaCambiada = await PreChangeBrandChosen(marca, props.budget)
        if(!marcaCambiada){
          setShowPopupPresupuestosPendientes(true)
          resolve(false)
        }else{
          resolve(true)
        }
      })
    }

    const handleClickExpositores = () => {
        if (location.pathname !== '/expositores') {
          changeBrandGlobal().then((res)=>{
            if(res == true) {  
              selectCategoryExpositor(props).then(res => {
                  navigate('/expositores')
              }).catch(err => {
                  console.log('err', err)
              })
            }
          })
        }
    };

    const handleClickImplantaciones = () => {
        if (location.pathname !== '/implantaciones') {
          changeBrandGlobal('scheurich').then((res)=>{
            if(res == true) {  
              selectCategoryImplantations(props).then(res => {
                  navigate('/implantaciones')
              }).catch(err => {
                  console.log('err', err)
              })
            }
          })
        }
    };

    const handleCloseDrawer = () => {
        closeDrawer(false)
    }

    const handleClickAway = () => {
        setModalOpen(false);
    };

    const handleClickAwayImplantaciones = () => {
        setModalOpenImplantaciones(false);
    };

    // const handleClickEnd = async () => {
    //     setShowPopupPresupuestosPendientes(false)
    // }

    const handleGoToExpoImplClick = async (marca) => {
      setModalOpenImplantaciones(false)
      if(marca == 'scheurich'){
        handleClickImplantaciones()
      }else {
        handleClickExpositores()
      }
    }

    return (
        <div className="menu-items-container">
          {showPopupPresupuestosPendientes &&
              <PopupOneButton title="¡Presupuestos pendientes!" text="Tienes presupuestos pendientes, para cambiar de marca debes guardar o eliminar los presupuestos." textButton="Aceptar" onClick={() => setShowPopupPresupuestosPendientes(false)} />
          }

            <div className="menu-item">
                <ClickAwayListener onClickAway={handleClickAway}>
                    <div className={`producto-menu-item ${isModalOpen || location.pathname.indexOf('/categoria') > -1 ? 'is-active' : ''}`}>
                        <div className="name-menu pointer" onClick={() => {console.log("click");setModalOpen(!isModalOpen)}}>
                            <p>Productos</p>
                            <div className={isModalOpen ? "arrow open" : "arrow"}><IoIosArrowForward /></div>
                        </div>
                        <div className="sub-menu">
                            {isModalOpen && (
                                <div className="sub-menuc-container">
                                    <div className="menu-collections pointer">
                                        <ProductosMenu onClick={handleCloseDrawer} closeMenu={() => setModalOpen(false)} menu={menu} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </ClickAwayListener>
            </div>

            <div className="menu-item pointer" onClick={handleCloseDrawer}>
                <a onClick={handleClickOutlet} className={`${location.pathname === '/outlet' ? 'is-active' : ''}`}><p>Outlet</p></a>
            </div>
            {/* <div className="menu-item pointer" onClick={handleCloseDrawer}>
                <a onClick={handleClickExpositores} className={`${location.pathname === '/expositores' ? 'is-active' : ''}`}><p>Expositores & PLV</p></a>
            </div> */}

            {/* //debug implantaciones descomentar */}
             <div className="menu-item">
                <ClickAwayListener onClickAway={handleClickAwayImplantaciones}>
                    <div className={`producto-menu-item ${(isModalOpenImplantaciones || location.pathname.indexOf('/implantacion') > -1 || location.pathname.indexOf('/expositor') > -1) ? 'is-active' : ''}`}>
                        <div className="name-menu pointer" onClick={() => setModalOpenImplantaciones(!isModalOpenImplantaciones)}>
                            <p>Implantaciones</p>
                            <div className={isModalOpenImplantaciones ? "arrow open" : "arrow"}><IoIosArrowForward /></div>
                        </div>
                        <div className="sub-menu">
                            {isModalOpenImplantaciones && (
                                <div className="sub-menuc-container">
                                    <div className="menu-collections menu-collections-implantaciones pointer">
                                        <div className="productos-menu-container-top-implantaciones">
                                            <div className="productos-menu-container">
                                                <div className="menu-item-container">
                                                    <div className="menu-item-content">
                                                        <div className="menu-item">
                                                            <div className="menu-item-text menu-item-img" onClick={() => handleGoToExpoImplClick(`fansa`)}>
                                                                <DeromaLogo size={50} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="menu-item-container">
                                                    <div className="menu-item-content">
                                                        <div className="menu-item">
                                                            <div className="menu-item-text menu-item-img" onClick={() => handleGoToExpoImplClick(`scheurich`)}>
                                                                  <ScheurichLogo size={35} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </ClickAwayListener>
            </div>

            <div className="menu-item" onClick={handleCloseDrawer}>
                {location.pathname.indexOf('/contacto') === -1 ?
                    <NavLink className={({ isActive }) => (isActive ? 'pointer is-active' : 'pointer')} to="/contacto"><p>Contacto</p></NavLink>
                    :
                    <a className={`${location.pathname === '/contacto' ? 'pointer is-active' : 'pointer'}`}><p>Contacto</p></a>
                }
            </div>
            <div className="menu-item" onClick={handleCloseDrawer}>
                {location.pathname.indexOf('/catalogos') === -1 ?
                    <NavLink className={({ isActive }) => (isActive ? 'pointer is-active' : 'pointer')} to="/catalogos"><p>Descargas</p></NavLink>
                    :
                    <a className={`${location.pathname === '/catalogos' ? 'pointer is-active' : 'pointer'}`}><p>Descargas</p></a>
                }
            </div>
        </div>

    )
}

const mapStateToProps = state => state

const mapDispatchToProps = {
    setAllProducts,
    setProductsTable,
    resetFilters,
    pushFilters,
    setPaginationState,
    setSelectedCategory,
    showSpinner
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuBar)
